if (!customElements.get("bundle-modal")) {
  customElements.define(
    "bundle-modal",
    class Bundles extends window.BAO.CustomElement {
      constructor() {
        super();

        this.hasBeenClosed = false;
        this.els = {};
        // Set the close button
        this.els.closeButton = this.querySelector(".bdl-button-close");
        this.els.secondaryCloseButton = this.querySelector(".bdl-button-sec-close");
        this.els.overlay = this.querySelector(".bndl-modal-overlay");
        this.els.bundleTrigger = document.querySelector(".bdl-trigger");
        

        // Set the add to cart button
        this.els.addToCartButton = document.querySelector(
          ".prd-Details_Button"
        );
        // Set the bundle landing page button
        this.els.bundlesButton = this.previousElementSibling

        // Set all product option buttons
        this.els.productOptionButtons = document.querySelectorAll(
          ".prd-Options_Button"
        );
        // Set the active product option button
        this.activeProductOptionButton = document.querySelector(
          ".prd-Options_Button[aria-pressed='true']"
        );

        // Set the active product option button when clicked
        this.els.productOptionButtons.forEach((button) => {
          button.addEventListener("click", () => {
            this.activeProductOptionButton = button;
          });
        });

        // Close the bundle module when the close button is clicked
        this.els.closeButton?.addEventListener("click", () => {
          this.close();
          this.hasBeenClosed = true;
        });

        // Close the bundle module when the secondary close button is clicked
        this.els.secondaryCloseButton?.addEventListener("click", () => {
          this.close();
          this.hasBeenClosed = true;
        });

        // Close the bundle module when the overlay is clicked
        this.els.overlay?.addEventListener("click", () => {
          this.close();
          this.hasBeenClosed = true;
        });

        this.els.bundlesButton?.addEventListener("click", () => {
          this.open();
          this.setProductOptionsInModal();
        });

        // Open the bundle module when the add to cart button is hovered
        // (!this.hasBeenClosed) The bundle module has not been previously closed
        // (!this.els.addToCartButton.disabled) The add to cart button is not disabled / a variant has been selected

        // added extra condition to check if the bundleTrigger exists
        if (this.els.bundleTrigger != null) {
          this.els.bundleTrigger?.addEventListener("click", () => {
            if (
              this.querySelector(".bndlr-container")
            ) {
              this.open();
              this.setProductOptionsInModal();
            }
          });
        } else {
          this.els.addToCartButton?.addEventListener("mouseover", () => {
            if (
              !this.els.addToCartButton.disabled &&
              !this.hasBeenClosed &&
              this.querySelector(".bndlr-container")
            ) {
              this.open();
              this.setProductOptionsInModal();
            }
          });
        }

        // This is how you can configure a listener for said event
        document.addEventListener("product:added", () => {
          window.location.reload();
        });
      }

      close() {
        this.classList.add("bdl-isHidden");
      }

      open() {
        this.classList.remove("bdl-isHidden");
      }

      // Set the product options in the modal
      setProductOptionsInModal() {
        this.els.modalProductOptions = this.querySelectorAll(
          ".bndlr-select-variant"
        );
        this.els.modalProductOptions.forEach((productOption) => {
          const targetOption = Array.from(productOption.children).find(
            (option) =>
              option.textContent ===
              this.activeProductOptionButton.dataset.title
          );

          // Select the option
          if (targetOption) targetOption.selected = true;
        });
      }
    }
  );
}
